<template>
  <section class="pa-section pa-section-park-finder">
    <PAParkFinderSelector />

    <PASectionPanelTitle
     :title="textTemplate[viewType]['mainPanel']['title']"
     :caption="textTemplate[viewType]['mainPanel']['caption']"
    />

    <PASectionPanelSubTitle
     :title="textTemplate[viewType]['subPanel']['title']"
     :caption="textTemplate[viewType]['subPanel']['caption']"
     :iconClass="textTemplate[viewType]['subPanel']['iconClass']"
    >
      <template slot="icon">
        <component :is="textTemplate[viewType]['subPanel']['iconComponent']"></component>
      </template>
    </PASectionPanelSubTitle>

    <div class="list-view-field">
      <PAParkPublicListView v-if="viewType === 'finder'" />
      <PAParkRelatedListView v-if="viewType === 'clips'" />
    </div>
  </section>
</template>

<script>
import PAParkFinderSelector from '@/components/Pages/Parks/Finder/PAParkFinderSelector.vue'

import PASectionPanelTitle from '@/components/Parts/PASectionPanelTitle/PASectionPanelTitle.vue'
import PASectionPanelSubTitle from '@/components/Parts/PASectionPanelSubTitle/PASectionPanelSubTitle.vue'

import PAParkSlashIcon from '@/components/Pages/Parks/Finder/Images/park_slash.svg?inlineN'
import PAParkClipIcon  from '@/components/Pages/Parks/Finder/Images/park_clip.svg?inlineN'

import PAParkPublicListView  from '@/components/Pages/Parks/Finder/PAParkPublicListView/PAParkPublicListView.vue'
import PAParkRelatedListView from '@/components/Pages/Parks/Finder/PAParkRelatedListView/PAParkRelatedListView.vue'

export default {
  components : {
    PAParkFinderSelector,

    PASectionPanelTitle,
    PASectionPanelSubTitle,

    PAParkSlashIcon,
    PAParkClipIcon,

    PAParkPublicListView,
    PAParkRelatedListView
  },

  computed : {
    viewType(){
      return this.$route.params.viewType;
    }
  },

  data(){
    return {
      textTemplate : {
        finder  : {
          mainPanel   : {
            title         : 'ひろばを探す',
            caption       : 'おすすめの広場を不定期でご紹介致します。',
          },

          subPanel    : {
            title         : '見つかったひろば',
            caption       : '２４区番外地管理局おすすめの広場一覧です。',
            iconClass     : [],
            iconComponent : 'PAParkSlashIcon',
          }
        },

        clips   : {
          mainPanel   : {
            title         : 'ひろば帳',
            caption       : 'ひろばへの扉を記録しておく特別な帳面で御座います。',
          },

          subPanel    : {
            title         : 'クリップしたひろば',
            caption       : '貴方様がクリップしたひろばへの扉で御座います。',
            iconClass     : ['pa-icon-clip'],
            iconComponent : 'PAParkClipIcon',
          }
        }
      }
    };
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-section{
  &-park-finder{
    padding-top:.5rem !important;
    padding-bottom:.5rem;
    margin-bottom: 1.5rem;

    @include from($desktop) {
      padding-top:.5rem !important;
    }

    .pa-park-finder-selector{
      margin-bottom: .5rem;
    }

    .list-view-field{
      position: relative;
      min-height:220px;

      .pa-park-list-view{
        li{
          &:last-child{
            margin-bottom:0;
          }
        }
      }

      .pa-fetch-button-park-list-view{
        width:96%;
        margin:0 auto;
      }
    }
  }
}
</style>